import BaseModel from "./base/baseModel";

export default class MotivoMovimentacaoEstoqueModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    tipoMotivo: number = null;
    tipoMotivoDescricao: string = null;
}
